import { FuseNavigationItem } from "@fuse/components/navigation";

export const userNavigation: FuseNavigationItem[] = [
    {
      id: 'userdashboards',
      title: 'Dashboards',
      type: 'group',
      icon: 'heroicons_outline:rectangle-group',
      children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
      id: 'datamanagement',
      title: 'Data Management',
      type: 'group',
      icon: 'heroicons_outline:server-stack',
      children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
      id: 'space-route',
      title: 'Space Route',
      type: 'spacer',
      children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
  ];